import React from "react";
import { Box, styled, Typography, useTheme } from "@mui/material";
import UserAvatar from "../../../../component/user-avatar";
import { ChatUser } from "../../../../api/user-request";
import { formatTime } from "../../../../utils/app-utils";

export type UserListItemProps = {
  user: ChatUser;
  handleUserSelect: () => void;
  isSelected: boolean;
};

interface StyledContainerProps {
  isSelected?: boolean;
}

const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<StyledContainerProps>(({ theme, isSelected }) => ({
  display: "flex",
  columnGap: "10px",
  alignItems: "center",
  padding: "0.8rem",
  borderBottom: `1px solid ${theme.palette.text.secondary}`,
  cursor: "pointer",
  transition: "all 0.5s",
  backgroundColor: isSelected
    ? theme.palette.grey.A200
    : theme.palette.background.paper,
  "&:hover": { backgroundColor: theme.palette.grey.A100 },
}));

const ChatListItem: React.FC<UserListItemProps> = ({
  user,
  handleUserSelect,
  isSelected,
}) => {
  const theme = useTheme();

  return (
    <StyledContainer onClick={handleUserSelect} isSelected={isSelected}>
      <UserAvatar profileImage={user?.profilePicture} />
      <Box>
        <Typography variant="subtitle2">
          {user.firstName} {user.lastName}
        </Typography>
        <Typography
          sx={{ color: theme.palette.grey[500], fontSize: 12 }}
          variant="subtitle2"
        >
          {user.lastMessageText}
        </Typography>
      </Box>
      <Typography
        sx={{ marginLeft: "auto", fontSize: "11px", bottom: 5, right: 10 }}
        variant="caption"
        display="block"
      >
        {user.lastMessageAt && formatTime(new Date(user.lastMessageAt))}
      </Typography>
    </StyledContainer>
  );
};

export default ChatListItem;
